"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Encoding = exports.Method = void 0;
var Method;
(function (Method) {
    Method["GET_DATA_LEGACY"] = "getDataLegacy";
    Method["GET_DATA"] = "getData";
    Method["DATA_COUNT"] = "dataCount";
    Method["ALL_DATA"] = "allData";
    Method["OWNER"] = "owner";
    Method["SUPPORTS_INTERFACE"] = "supportsInterface";
})(Method = exports.Method || (exports.Method = {}));
var Encoding;
(function (Encoding) {
    Encoding["BYTES"] = "bytes";
    Encoding["BOOL"] = "bool";
    Encoding["UINT256"] = "uint256";
    Encoding["BYTES32_ARRAY"] = "bytes32[]";
    Encoding["BYTES_ARRAY"] = "bytes[]";
    Encoding["ADDRESS"] = "address";
})(Encoding = exports.Encoding || (exports.Encoding = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0aG9kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3R5cGVzL01ldGhvZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLE1BT1g7QUFQRCxXQUFZLE1BQU07SUFDaEIsMkNBQWlDLENBQUE7SUFDakMsOEJBQW9CLENBQUE7SUFDcEIsa0NBQXdCLENBQUE7SUFDeEIsOEJBQW9CLENBQUE7SUFDcEIseUJBQWUsQ0FBQTtJQUNmLGtEQUF3QyxDQUFBO0FBQzFDLENBQUMsRUFQVyxNQUFNLEdBQU4sY0FBTSxLQUFOLGNBQU0sUUFPakI7QUFFRCxJQUFZLFFBT1g7QUFQRCxXQUFZLFFBQVE7SUFDbEIsMkJBQWUsQ0FBQTtJQUNmLHlCQUFhLENBQUE7SUFDYiwrQkFBbUIsQ0FBQTtJQUNuQix1Q0FBMkIsQ0FBQTtJQUMzQixtQ0FBdUIsQ0FBQTtJQUN2QiwrQkFBbUIsQ0FBQTtBQUNyQixDQUFDLEVBUFcsUUFBUSxHQUFSLGdCQUFRLEtBQVIsZ0JBQVEsUUFPbkIifQ==